import { FC } from 'react';
import styles from './ScheduleCard.module.css';

interface ScheduleCardProps {
  homeTeam: string;
  awayTeam: string;
  gameDate: string;
  teamColor?: string;
  teamAccent?: string;
}

export const ScheduleCard: FC<ScheduleCardProps> = ({ homeTeam, awayTeam, gameDate, teamColor = '#555', teamAccent = '#fff' }) => {
  return (
    <div className={styles.card}>
      <div className={styles.colorBar} style={{ backgroundColor: teamColor }} />
      <div className={styles.body}>
        <div className={styles.matchup}>
          <span className={styles.away}>{awayTeam}</span>
          <span className={styles.at}>@</span>
          <span className={styles.home} style={{ color: teamColor }}>{homeTeam}</span>
        </div>
        <div className={styles.time}>{gameDate}</div>
      </div>
    </div>
  );
}
